import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Button,
} from "@material-tailwind/react";
import { BiSolidTimeFive } from "react-icons/bi";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "@material-tailwind/react";



const ToolTipResults = ({ scheduledOn, resultOn }) => {
    return (
        <Tooltip
            placement="bottom"
            className="bg-white border border-blue-gray-50 shadow-xl shadow-black/10 px-4 py-3"
            content={
                <div className="w-80">
                    <Typography color="blue-gray" className="font-medium">Test Scheduling and Declaration</Typography>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal opacity-80"
                    >
                        {scheduledOn ? (
                            <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                                <Typography className="font-normal my-1">Scheduled on - {scheduledOn}</Typography>
                            </li>
                        ) : (
                            <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                                <Typography className="font-normal my-1">Not Scheduled</Typography>
                            </li>
                        )}
                        {resultOn ? (
                            <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                                <Typography className="font-normal my-1">Result on - {resultOn}</Typography>
                            </li>
                        ) : (
                            <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                                <Typography className="font-normal my-1">Result Declared</Typography>
                            </li>

                        )}
                    </Typography>
                </div>
            }
        >
            <div className="flex justify-end align-middle m-1 p-1">

                <InformationCircleIcon
                    strokeWidth={2}
                    className="text-blue-gray-500 w-5 h-5 cursor-pointer inline"
                /> About Test
            </div>
        </Tooltip>
    )
}



const AllTestCards = ({ name = "Test Name", duration = "-", test, classs = "-", type, callbackEdit, callbackDelete, scheduledOn = null, resultOn = null }) => {
    return (
        <Card variant="gradient" className="w-full max-w-[19rem] m-2 p-3 py-5 h-max bg-bgBlue text-white border-gray-400 border-2">
            <ToolTipResults scheduledOn={scheduledOn} resultOn={resultOn} />
            <CardHeader
                floated={false}
                className="m-0 mb-5 border-2 border-white/10 bg-bgBlue text-white text-center rounded h-16 text-ellipsis"
            >
                <Typography
                    className="flex justify-center align-middle gap-1 font-bold text-xl"
                >
                    {name}
                </Typography>
            </CardHeader>
            <CardBody className="p-0 ">
                <ul className="flex flex-col gap-2">
                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded-full border border-black bg-white/20">
                            <BiSolidTimeFive className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">{duration} Minutes</Typography>
                    </li>
                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <Typography className="font-normal my-1">{classs}</Typography>
                    </li>
                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <Typography className="font-normal my-1">Type - {type || "Immediate Result Test"}</Typography>
                    </li>
                </ul>
            </CardBody>
            <CardFooter className="p-0 flex justify-center m-3 gap-4">
                <Button
                    // color=
                    className="text-white hover:scale-[1.02] focus:scale-[1.02] active:scale-100 bg-[#C14B0B]"
                    onClick={(e) => { callbackEdit(e, test) }}
                >
                    Edit
                </Button>
                <Button
                    // color="##F8333C"
                    className="text-white hover:scale-[1.02] focus:scale-[1.02] active:scale-100 bg-[#dd353df5]"
                    onClick={(e) => { callbackDelete(e, test) }}
                >
                    Delete
                </Button>
            </CardFooter>
        </Card>
    );
}

export default AllTestCards;